import { useTranslation } from "react-i18next";
import { Page } from "../../../../components/Page";
import { WithAuthorization } from "../../../../context";
import { Card } from "../../../../components/Card";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";
import SustainableFinanceRegulationsDescription from "./components/SustainableFinanceRegulationsDescription";
import SustainableFinanceRegulationsInfo from "./components/SustainableFinanceRegulationsInfo";

function SustainableFinanceRegulation() {
  const { t } = useTranslation("translation", {
    keyPrefix: "sustainableFinanceRegulation"
  });

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.description")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.sustainableFinanceRegulations")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <SustainableFinanceRegulationsDescription></SustainableFinanceRegulationsDescription>
            </TabPanel>
            <TabPanel padding="0">
              <SustainableFinanceRegulationsInfo></SustainableFinanceRegulationsInfo>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(SustainableFinanceRegulation);